import {ThemeProps} from 'flowbite-react';

export const internalTheme: ThemeProps = {
  theme: {
    label: {
      root: {
        base: 'font-internal text-sm',
      },
    },
    button: {
      base: 'font-internal bg-codGray hover:bg-codGray justify-center flex flex-row',
    },
    textInput: {
      base: 'font-internal',
      field: {input: {base: 'block w-full border !text-base font-internal'}},
    },
  },
};

export const creatorPortalTheme: ThemeProps = {
  theme: {
    textInput: {
      base: 'font-internal',
      field: {
        input: {base: 'block w-full border !text-base bg-white !font-internal'},
      },
    },
    helperText: {root: {base: 'font-internal text-codGray600 pt-1 text-sm'}},
    toggleSwitch: {
      toggle: {
        base: 'toggle-bg h-[22px] w-11 rounded-full relative after:h-[18px] after:w-[18px]',
        checked: {
          color: {
            off: '#e5e5e5',
          },
          on: 'after:translate-x-full after:left-[6px] !bg-brand800',
        },
      },
    },
  },
};
